import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import CustomInput from '../../components/CustomInput/CustomInput';

const useStyles = () => ({
  root: {
    width: '400',
    display: 'flex',
    flexDirection: 'column',
  },
});

class Form extends Component {
  render() {
    const {
      classes, handleChange, name, description, elemenntId,
    } = this.props;

    return (
      <div className={classes.root}>
        <CustomInput id='name' disabled={elemenntId} label='Name' value={name} onChange={(id) => handleChange(id)} />
        <CustomInput id='description' label='Description' value={description} onChange={(id) => handleChange(id)} />
      </div>
    );
  }
}

export default withStyles(useStyles)(Form);
